// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1abxX","form":"styles_form__1BBp1"};